import { createElement } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

const SvgDeclineIcon = (props: SvgIconProps) =>
  createElement(
    SvgIcon,
    props,
    <path
      clipRule="evenodd"
      d="m20.175 10.751-2.87-5.269c-.449-.805-1.26-1.3-2.142-1.3H9.426c-.882 0-1.694.495-2.126 1.3l-2.885 5.269a2.77 2.77 0 0 0 0 2.598l2.868 5.27c.432.804 1.262 1.299 2.126 1.299h5.754c.882 0 1.694-.494 2.126-1.3l2.869-5.27a2.72 2.72 0 0 0 .017-2.597m-5.047 3.404c-.173 1.244-.45 2.47-1.624 2.47-.898 0-1.434-.019-2.315-.019-.45 0-.847-.385-1.14-.75-.692-.824-1.815-2.8-1.815-2.8a.647.647 0 0 1 .173-.878c.276-.183.536-.073.795.201.259.275.709.86.709.86.241.256.45.091.431-.164-.017-.458-.052-.75-.103-1.263-.052-.512-.467-2.908-.467-2.908a.543.543 0 0 1 .432-.64c.294-.056.553.146.605.457l.449 2.964c.017.072.069.146.155.146h.052c.104 0 .173-.073.173-.183l-.19-3.586a.543.543 0 0 1 .5-.586c.294-.018.536.22.553.53l.19 3.751a.16.16 0 0 0 .156.165c.086 0 .173-.073.173-.165l.155-3.22c.017-.311.259-.55.553-.53a.544.544 0 0 1 .5.585l-.155 3.22c0 .092.07.183.155.183h.018a.17.17 0 0 0 .173-.146l.293-2.489c.035-.31.294-.53.588-.476.293.037.484.311.45.622-.017-.017-.449 3.404-.622 4.648"
      fill="currentColor"
      fillRule="evenodd"
    />,
  )
export default SvgDeclineIcon
